export default __webpack_public_path__ + "static/unboxingLogo@2x-a3c3885bcbcd06d70a44dc00688a61eb.png";